import styled from 'styled-components';

const FlexAvatar = styled.img<{ maxWidth?: string; maxHeight?: string }>`
  max-width: ${p => p.maxWidth || '160px'};
  max-height: ${p => p.maxHeight || '80px'};
  object-fit: contain;
  /* border-radius: 6px; */
`;

export default FlexAvatar;
